import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[wimInsertStep]',
})
export class InsertStepDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
